/* eslint-disable */
import { api } from './../../api.js';

const state = {
    token : null,
    is_logged : false,
    role : 0,
    page_loading : false,
    user : null
};

const getters = {
    getUserToken : (state) => {
        return state.token;
    },
    isLogged : (state) => {
        return state.is_logged;
    },
    getRole : (state) => {
        return state.role;
    },
    getMenuActive : (state) => {
        return state.menu_active;
    },
    getSearchActive : (state) => {
        return state.search_active;
    },
    getUserContentActive : (state) => {
        return state.user_content_active;
    },
    getPageLoading : (state) => {
        return state.page_loading;
    },
    getPermissions : (state) => {
        return state.permissions;
    },
    getName : (state) => {
        return state.name;
    },
    getUser : (state) => {
        return state.user;
    }

}

const mutations = {
    setUserToken : (state, token) => {
        state.token = token;
        localStorage.setItem('token', token);
    },

    setIsLogged : (state, is_logged) => {
        state.is_logged = is_logged;
    },

    setRole : (state, role) => {
        state.role = role;
    },
    setMenuActive : (state) => {
        state.search_active = false;
        state.user_content_active = false;
        state.menu_active = !state.menu_active;
    },
    setSearchActive : (state) => {
        state.menu_active = false;
        state.user_content_active = false;
        state.search_active = !state.search_active;
    },
    setUserContentActive : (state) => {
        state.menu_active = false;
        state.search_active = false;
        state.user_content_active = !state.user_content_active;
    },
    setPageLoading : (state, loading) => {
        state.page_loading = loading;
    },
    setPermissions : (state, permissions) => {
        state.permissions = permissions;
    },
    setName : (state, name) => {
        state.name = name;
    },
    setUser : (state, user) => {
        state.user = user;
    }
}

const actions = {
    login : function({ commit }, data){

        //return a promise to catch the response outside vuex in LoginComponent
        return new Promise((resolve, reject) => {
            api.post('auth/login', data.login_data).then((res) => {

                if(res.data.auth){
                    commit('setUserToken', res.data.access_token);
                    commit('setIsLogged', res.data.auth);
                    commit('setRole', res.data.rol);
                    commit('setUser', res.data.user);
                }else{
                    reject(res);
                }

                resolve(res);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    logout : function({ commit }, data){

        commit('setUserToken', null);
        commit('setIsLogged', false);
        commit('setPermissions', []);
        commit('setUser', null);
    },

    checkAccessToken : function({ commit }){
        if(localStorage.getItem('token')){
            //aquí tendríamos un check del token
            return new Promise((resolve, reject) => {
                api.post('auth/check', {}).then((res) => {
                    commit('setUserToken', res.data.access_token);
                    commit('setIsLogged', true);
                    commit('setRole', res.data.rol);
                    commit('setUser', res.data.user);
                    resolve(res);
                }).catch((error) => {
                    commit('setUserToken', null);
                    commit('setIsLogged', false);
                    commit('setUser', null);
                    reject(error.response);
                });
            });
        }
    },

    checkToken : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('auth/token', data).then((res) => {
                commit('setUserToken', res.data.access_token);
                commit('setIsLogged', true);
                commit('setRole', res.data.rol);
                commit('setUser', res.data.user);
                resolve(res);
            }).catch((error) => {
                commit('setUserToken', null);
                commit('setIsLogged', false);
                commit('setUser', null);
                reject(error.response);
            });
        });
    },

    sendResetPasswordEmail : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('send-reset-password/'+data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    forgotPassword : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('reset-password', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    resetPassword2 : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('reset-pass', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    editProfile : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('profile', data).then((res) => {

                commit('setName', res.data.user.name);
                commit('setUser', res.data.user);

                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    getEstado : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('estado', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AuthModule.js